import { render, staticRenderFns } from "./Migracion.vue?vue&type=template&id=686a0fe4"
import script from "./Migracion.vue?vue&type=script&lang=js"
export * from "./Migracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports